<template>
  <v-dialog persistent v-model="showDialog" scrollable max-width="800px">
    <v-card>
      <v-card-title>
        <strong>เพิ่มสินค้าใหม่</strong>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 450px;">
        <el-form :label-position="`left`" size="medium" label-width="100px" class="mt-3 pl-3">
          <!--
          <el-form-item label="ร้านค้า">
            <el-select
              v-model="form.shop_id"
              filterable
              placeholder="เลือกร้านค้า"
              style="width:350px;"
            >
              <el-option
                v-for="item in shopList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          -->
          <el-form-item label="ชื่อสินค้า">
            <el-col :span="19">
              <el-input v-model="form.name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="คำอธิบาย">
            <el-col :span="19">
              <el-input v-model="form.excerpt"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="ประเภท">
            <el-col :span="19">
              <el-radio-group v-model="form.product_type" @change="onTypeChanged">
                <el-radio :label="`a_la_carte`">อาหารจานเดียว</el-radio>
                <el-radio :label="`customise`">อาหารที่มีตัวเลือก</el-radio>
                <el-radio :label="`product`">สินค้าอีคอมเมิร์ซ</el-radio>
                <el-radio :label="`coupon`" :disabled="true">คูปอง/บัตรกำนัล</el-radio>
                <el-radio :label="`free_item`">ของแถม</el-radio>
                <!-- <el-radio :label="`modifier`">Modifier</el-radio> -->
              </el-radio-group>
            </el-col>
          </el-form-item>
          <el-form-item label="ราคาขาย">
            <el-col :span="19">
              <el-input :disabled="disablePrice" type="number" v-model="form.regular_price"></el-input>
            </el-col>
          </el-form-item>
          <!--
          <el-form-item label="ราคาต้นทุน">
            <el-col :span="19">
              <el-input v-model="form.cog"></el-input>
            </el-col>
          </el-form-item>
          -->
          <!--
          <el-form-item label="Coordinate">
            <el-col :span="9">
              <el-form-item>
                <el-input v-model="form.shop_latitude"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1">&nbsp;</el-col>
            <el-col :span="9">
              <el-form-item>
                <el-input v-model="form.shop_longitude"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          -->
        </el-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="showDialog = false">ปิด</v-btn>
        <v-btn color="red darken-2" flat @click="onSave">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../services";
import { monthList } from "../utils/Constants";

export default {
  name: "create-product-drawer",
  props: {
    dialog: { default: false },
    shopId: { default: null }
  },
  data() {
    return {
      shopList: [],
      form: {
        shop_id: null,
        status: "draft",
        product_type: "a_la_carte",
        name: "",
        excerpt: "",
        regular_price: null,
        cog: null
      },
      disablePrice: false
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  created() {
    Service.Shop.gets().then(res => {
      this.shopList = res.data.map(item => {
        return { label: item.name, value: item.shop_id };
      });
    });
  },
  mounted() {
    this.form.shop_id = this.shopId;
  },
  methods: {
    onTypeChanged() {
      if (this.form.product_type == "free_item") {
        this.form.regular_price = 0;
        this.disablePrice = true;
      } else {
        this.form.regular_price = null;
        this.disablePrice = false;
      }
    },
    onSave() {
      this.form.cog = this.form.regular_price;
      Service.Product.add(this.form).then(res => {
        if (res.success) {
          this.form = {
            shop_id: this.shopId,
            status: "draft",
            product_type: "a_la_carte",
            name: "",
            excerpt: "",
            regular_price: null,
            cog: null
          };
          this.$emit("save");
        }
      });
    }
  }
};
</script>